import * as React from 'react';
import cn from 'classnames';

import { AreaPartItemProps } from './types';

import * as styles from './AreaPartItem.css';

export const AreaPartItem: React.FC<AreaPartItemProps> = props => {
  const { children, isMobile, isEmpty, title } = props;

  return (
    <div className={cn(styles['field-container'], isMobile && styles['mobile'])}>
      <div className={styles['title']}>{title}</div>
      <div className={cn(styles['container'], isEmpty && styles['empty'])}>{children}</div>
    </div>
  );
};
